import { reducerWithInitialState } from "typescript-fsa-reducers";
import { State } from "./social.types";
import * as actions from "./social.actions";

export const initialState: Readonly<State> = {
  profiles: {
    isProfilesLoading: false,
    profileList: undefined,
  },
  post: {
    isPostLoading: false,
    postList: undefined,
    error: undefined,
  },
  pricing: {
    isPricingLoading: false,
    pricingObject: undefined,
  },
  report: {
    isSocialReportLoading: false,
    detail: undefined,
    success: undefined,
    error: undefined,
    isReportReady: false,
  },
};

export default reducerWithInitialState(initialState)
  .case(actions.resetSocial, () => ({ ...initialState }))
  .case(actions.isProfilesLoading, (state, { isProfilesLoading }) => ({
    ...state,
    profiles: {
      ...state.profiles,
      isProfilesLoading,
    },
  }))
  .case(actions.profileList, (state, { profileList }) => ({
    ...state,
    profiles: {
      ...state.profiles,
      profileList,
    },
  }))
  .case(actions.isPostLoading, (state, { isPostLoading }) => ({
    ...state,
    post: {
      ...state.post,
      isPostLoading,
    },
  }))
  .case(actions.postList, (state, { postList }) => ({
    ...state,
    post: {
      ...state.post,
      postList,
    },
  }))
  .case(actions.postError, (state, { error }) => ({
    ...state,
    post: {
      ...state.post,
      error,
    },
  }))
  .case(actions.isPricingLoading, (state, { isPricingLoading }) => ({
    ...state,
    pricing: {
      ...state.pricing,
      isPricingLoading,
    },
  }))
  .case(actions.pricingObject, (state, { pricingObject }) => ({
    ...state,
    pricing: {
      ...state.pricing,
      pricingObject,
    },
  }))
  .case(actions.reportSuccess, (state, { success }) => ({
    ...state,
    report: {
      ...state.report,
      success,
    },
  }))
  .case(actions.reportError, (state, { error }) => ({
    ...state,
    report: {
      ...state.report,
      error,
    },
  }))
  .case(actions.reportDetail, (state, { detail }) => ({
    ...state,
    report: {
      ...state.report,
      detail,
    },
  }))
  .case(actions.isSocialReportLoading, (state, { isSocialReportLoading }) => ({
    ...state,
    report: {
      ...state.report,
      isSocialReportLoading,
    },
  }))
  .case(actions.isReportReady, (state, { isReportReady }) => ({
    ...state,
    report: {
      ...state.report,
      isReportReady,
    },
  }))
  .build();
